import { get, post, del, postForm } from "../helpers/api_helper"

// Companies
export const getTenantCompanies = () => get("tenant-companies")
export const suggestCompanyCode = name => get(`tenant-companies/suggest-code?name=${encodeURIComponent(name || "")}`)
export const getTenantCompany = id => get(`tenant-companies/${id}`)
export const createTenantCompany = data => post("tenant-companies", data)
export const updateTenantCompany = (id, data) => post(`tenant-companies/${id}`, data)
// Branding logos (multipart). fd = FormData with any of: logo, header_logo, watermark_logo
export const uploadCompanyLogos = (id, fd) => postForm(`tenant-companies/${id}/logos`, fd)
// Per-company voucher numbering overrides
export const getCompanyNumbering = id => get(`tenant-companies/${id}/voucher-numbering`)
export const saveCompanyNumbering = (id, rows) => post(`tenant-companies/${id}/voucher-numbering`, { rows })
export const toggleTenantCompany = id => post(`tenant-companies/${id}/active`, {})
// Company documents (Documents Manager 'company' master → Company form)
export const getCompanyDocuments = id => get(`tenant-companies/${id}/documents`)
export const saveCompanyDocuments = (id, fd) => postForm(`tenant-companies/${id}/documents`, fd)
// Company bank accounts (mirrored into Finance as Bank-group ledgers)
export const getCompanyBankAccounts = id => get(`tenant-companies/${id}/bank-accounts`)
export const createCompanyBankAccount = (id, data) => post(`tenant-companies/${id}/bank-accounts`, data)
export const updateCompanyBankAccount = (id, accId, data) => post(`tenant-companies/${id}/bank-accounts/${accId}`, data)
export const deleteCompanyBankAccount = (id, accId) => del(`tenant-companies/${id}/bank-accounts/${accId}`)
export const assignUserCompanies = (userId, data) => post(`users/${userId}/companies`, data)

// Groups
export const getCompanyGroups = () => get("company-groups")
export const getCompanyGroup = id => get(`company-groups/${id}`)
export const createCompanyGroup = data => post("company-groups", data)
export const updateCompanyGroup = (id, data) => post(`company-groups/${id}`, data)
export const deleteCompanyGroup = id => del(`company-groups/${id}`)

// Scoped settings
export const getGroupSettings = id => get(`group-settings/${id}`)
export const saveGroupSettings = (id, settings) => post(`group-settings/${id}`, { settings })
export const getCompanySettings = id => get(`company-settings/${id}`)
export const saveCompanySettings = (id, settings) => post(`company-settings/${id}`, { settings })
